module.exports = __webpack_public_path__ + "static/media/Show.137a7e86.svg";